import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export function formatViews(n: number): string {
  if (n >= 10000) {
    return `${(n / 10000).toFixed(1)}万`;
  }
  return `${n}`;
}

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col rounded-2xl bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} 喵趣漫画养猫日常封面`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2.5 left-2.5 rounded-full bg-foreground-950/70 text-background-50 text-xs px-2.5 py-1 backdrop-blur">
          {comic.status}
        </span>
        <span className="absolute bottom-2.5 left-2.5 rounded-full bg-primary-500 text-background-50 text-xs px-2.5 py-1">
          {comic.category}
        </span>
      </div>
      <div className="p-3.5 flex flex-col gap-1.5">
        <h3 className="font-heading text-base text-foreground-950 truncate group-hover:text-primary-600">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600 truncate">{comic.latestChapter}</p>
        <div className="flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500"></i>
            {formatViews(comic.views)}人气
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500"></i>
            {comic.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}